export const TELEGRAM_URL = process.env.VUE_APP_TELEGRAM_AUTHORIZATION_URL || 'https://t.me/SDOpfdoBot';

export const LESSON_TYPES = {
  fullTime: 1,
  partTime: 2,
};

export const LESSON_TYPE_NAMES = {
  [LESSON_TYPES.fullTime]: 'Очное обучение',
  [LESSON_TYPES.partTime]: 'Заочное обучение',
};

export const TASK_STATUSES = {
  retake: 1,
  success: 2,
  fail: 3,
  done: 4,
  notPassed: 5,
  notChecked: 6,
  inProcess: 7,
};

export const TASK_STATUS_NAMES = {
  1: 'На пересдачу',
  2: 'Зачет',
  3: 'Незачет',
  4: 'Выполнено',
  5: 'Не пройдено',
  6: 'Ожидает проверки',
  7: 'В процессе',
};
export const TASK_STATUS_COLORS = {
  1: 'error',
  2: 'success',
  3: 'error',
  4: 'success',
  5: '',
  6: 'warning lighten-2',
  7: 'warning lighten-2',
};

export const COURSE_STATUSES = {
  active: 1,
  draft: 2,
};
export const COURSE_STATUSES_NAMES = {
  1: 'Активный',
  2: 'Черновик',
};

export const COURSE_EXCHANGE_STATUSES = {
  active: 1,
  new: 2,
  closed: 3,
};

export const COURSE_EXCHANGE_STATUSES_NAMES = {
  1: 'Активный',
  2: 'Требует активации',
  3: 'Неактивный',
};

// Для кого предназначен курс:
export const COURSE_TYPES = {
  general: 1,
  qualification: 2,
  professional: 3,
  personal: 4,
};

export const COURSE_TYPES_TEXT = {
  [COURSE_TYPES.general]: 'Курс дополнительного образования для детей',
  [COURSE_TYPES.qualification]: 'Курс  повышения квалификации',
  [COURSE_TYPES.professional]: 'Курс профессионального развития',
  [COURSE_TYPES.personal]: 'Курс личностного роста',
};

export const COURSE_TYPES_ICONS = {
  [COURSE_TYPES.general]: 'mdi-school-outline',
  [COURSE_TYPES.qualification]: 'mdi-sort-clock-descending-outline',
  [COURSE_TYPES.professional]: 'mdi-school-outline',
  [COURSE_TYPES.personal]: 'mdi-sort-clock-descending-outline',
};

export const COURSE_TYPE_NAMES = [
  {
    id: COURSE_TYPES.general,
    name: 'Курс дополнительного образования для детей',
  },
  {
    id: COURSE_TYPES.qualification,
    name: 'Курс  повышения квалификации',
  },
  {
    id: COURSE_TYPES.professional,
    name: 'Курс профессионального развития',
  },
  {
    id: COURSE_TYPES.personal,
    name: 'Курс личностного роста',
  },
];

export default {
  LESSON_TYPES,
  LESSON_TYPE_NAMES,
  TASK_STATUSES,
  TASK_STATUS_NAMES,
  COURSE_STATUSES,
  COURSE_EXCHANGE_STATUSES,
  COURSE_EXCHANGE_STATUSES_NAMES,
  COURSE_TYPES,
  TASK_STATUS_COLORS,
  COURSE_TYPE_NAMES,
  COURSE_TYPES_TEXT,
  COURSE_TYPES_ICONS,
  TELEGRAM_URL,
};
